import React from "react";
import PublicationCard from "./PublicationCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Publications = () => {
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div id='publications' className='mt-4 text-white'>
      <h1 className='text-2xl font-bold'>Publications</h1>
      <p className='font-light text-gray-400'>
        Here are some of my Publications
      </p>

      <div className='mt-4'>
        <Slider {...settings}>
          <PublicationCard
            name='Interpretable Disease Classification in Plant Leaves using Deep
Convolutional Neural Networks'
            venue="25th International Conference on Computer and Information Technology
            (ICCIT), Cox's Bazar, Bangladesh
            "
            authors='Mohammad Rakibul Hasan Mahin, Waheed Moonwar, Md. Shamsul Rayhan
            Chy, Fahim Faisal Rafi, Md. Fahim Shahriar, Dewan Ziaul Karim, Annajiat
            Alim Rasel'
          />
          <PublicationCard
            name='Classifying Corn Leaf Diseases using Ensemble Learning with Dropout and
Stochastic Depth Based Convolutional Networks'
            venue='8th International Conference on Machine Learning Technologies (ICMLT),
Stockholm, Sweden [Submitted]'
            authors='Md. Shamsul Rayhan Chy, Mohammad Rakibul Hasan Mahin, Md.
Farhadul Islam, Md Sabbir Hossain, and Annajiat Alim Rasel
'
          />
        </Slider>
      </div>
    </div>
  );
};

export default Publications;
